<template>
	<div v-if="show">
		<ja-modal ref="modal" class="modal-component" :show="show">
			<content class="content">
				<img
					alt=""
					class="page-icon"
					:src="require(`@/assets/images/Jimmy-modal.png`)"
				/>
				<div class="modal-wrapper-content">
					<div class="title-wrapper">
						<h1 class="heading-3">
							{{
								$t('greeting', {
									name: lifeStageData.formStudentName ?? userData.firstName
								})
							}}
						</h1>
					</div>

					<div class="text-wrapper">
						<div class="body-text-1">{{ bodyText }}</div>
						<div v-if="showBillsAreDueFormat" class="button body-text-1">
							<ja-button
								class="transparent action-link"
								name="keepShopping"
								@click.native="continueShopping"
							>
								{{ $t('keepShopping') }}
							</ja-button>
						</div>
						<div class="button body-text-1">
							<ja-button
								class="transparent action-link"
								name="finishLifeStage"
								@click.native="finishLifeStage"
							>
								{{ completeLifeStageButtonText }}
							</ja-button>
						</div>
					</div>
				</div>
			</content>
		</ja-modal>
	</div>
</template>
<script>
import '../icons/modal-close';
import '../icons/calculation';
import '../icons/score';
import '../icons/target';
import '../icons/paying';
import '../icons/general-savings';

import Modal from './Modal';
import LifeStageData from '@/mixins/LifeStageData';
import ProfileData from '@/mixins/ProfileData';
import gql from 'graphql-tag';
import UserData from '@/mixins/UserData';
import ModalEvents from '@/mixins/ModalEvents';
import Button from '@/components/ui/Button';

export default {
	components: {
		jaModal: Modal,
		jaButton: Button
	},
	mixins: [UserData, LifeStageData, ProfileData, ModalEvents],
	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			currentStep: 0,
			buttonDisabled: false,
			steps: [
				{
					title: this.$t('welcomeToJAFinancePark'),
					text: this.$t('welcomeToJAFinanceParkText'),
					buttonDisabled: false
				}
			],
			expandedModal: false
		};
	},
	computed: {
		isButtonDisabled() {
			return this.steps[this.currentStep].buttonDisabled;
		},
		studentIsOlderThanYoungAdult() {
			if (this.profileData.cmsLifeStage) {
				return this.profileData.cmsLifeStage.displayOrder > 1;
			}
			return null;
		},
		bodyText() {
			if (this.showBillsAreDueFormat) {
				return this.$t('itsAlmostTime');
			}
			return this.$t('yourBillsAreDue');
		},
		completeLifeStageButtonText() {
			if (this.showBillsAreDueFormat) {
				return this.$t('completeLifeStageAndContinue');
			}
			return this.$t('continueToPayment');
		},
		lifeStageCompletionPercentage() {
			if (this.lifeStageData) {
				return this.lifeStageData.currentLifeStageCompletionPercentage;
			}
			return null;
		},
		allExpenseCategoriesAreCompleted() {
			const completedGamePercentage = 100;
			return this.lifeStageCompletionPercentage < completedGamePercentage;
		},
		showBillsAreDueFormat() {
			return (
				this.studentIsOlderThanYoungAdult ||
				this.allExpenseCategoriesAreCompleted
			);
		}
	},
	methods: {
		continueShopping() {
			this.$emit('toggleCompleteLSBtnState');
		},
		closeModal() {
			this.$emit('toggleLifeStageCompletionModal');
		},
		async hideLifeStageCompletionModal() {
			const modalStatusInfo = {
				id: this.userData.studentId,
				hideLifeStageCompletionPopup: true
			};

			await this.$apollo.mutate({
				mutation: gql`
					mutation($update: StudentInputObjectGraphType!) {
						updateIgnoreNullValuesStudent(update: $update) {
							id
						}
					}
				`,
				variables: {
					update: modalStatusInfo
				}
			});
		},
		finishLifeStage() {
			this.lifeStageData.hideLifeStageCompletionPopup = true;
			this.hideLifeStageCompletionModal();
			this.closeModal();
			this.$emit('completeLifeStage');
		}
	}
};
</script>
<style lang="scss" scoped>
.modal-component {
	::v-deep .modal {
		max-width: 500px;
		@media (min-width: $breakpoint-mid) {
			max-width: 600px;
		}
	}
}

content {
	position: relative;
	align-items: inherit !important;

	.page-icon {
		max-width: 330px;
		max-height: 250px;
		align-self: center;
		width: 40%;
		margin-top: -80px;
		@media (min-width: $breakpoint-mid) {
			margin-top: -95px;
		}
	}

	.heading-3 {
		margin: 12px 0 12px 0;
	}

	.modal-wrapper-content {
		width: 75%;
		align-self: center;
		margin-bottom: 24px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: initial;

		.text-wrapper {
			.action-link {
				color: $font-blue;
				cursor: pointer;
				margin-top: 24px;
			}
		}
	}
}
</style>
